import React, { useCallback } from 'react';
import { View } from 'react-native';
import {
  Banner,
  Button,
  ContractSellerButton,
  KeyboardScreenContainer,
  ProtectionResumeItemCard,
  ServicePriceCard,
  Text,
} from '~/components';
import Footer from '../Footer';
import { isWeb } from '~/utils/device';
import INSURANCES from '~/utils/insurance';

import GeneralInfoFooter from '~/scenes/BagProtection/components/GeneralInfoFooter';
import { formatMoney } from '~/utils';
import { bagProtectionResumeItems } from '~/utils/services';
import { useCheckout } from '~/stores';
import useBagProtectionForm from '~/stores/bagProtectionForm';
import type { StepComponentProps } from '~/components/StepsForm';

const INSURANCE_TYPE = 'bag-protection';

const BagProtectionContractResume: React.FC<StepComponentProps> = ({
  onContinue,
}) => {
  const { setInsuranceFormData, setContractSeller } = useCheckout();
  const { form } = useBagProtectionForm();

  const insuranceInfos = INSURANCES.find(
    (insurance) => insurance.type === INSURANCE_TYPE
  );

  const handleSetInsuranceFormData = useCallback(() => {
    setInsuranceFormData(form);
  }, [form, setInsuranceFormData]);

  const handleContinue = useCallback(() => {
    handleSetInsuranceFormData();

    setContractSeller(null);

    onContinue?.();
  }, [handleSetInsuranceFormData, onContinue, setContractSeller]);

  if (!insuranceInfos) return null;

  return (
    <KeyboardScreenContainer
      footer={
        <View className="flex xl:hidden">
          <Footer onSubmit={handleContinue} label="CONTINUAR PARA PAGAMENTO" />
        </View>
      }
    >
      <View className="flex-1 container mx-auto xl:flex-row xl:pt-12 xl:pb-24">
        <Banner type="bag-protection" />

        <View className="mt-8 xl:mt-0 px-6 flex-1 xl:ml-24">
          <Text className="text-lg text-gray-600">Resumo da contratação</Text>

          <Text className="text-xs text-primary-600 mb-6">Proteção Bolsa</Text>

          <ServicePriceCard value={formatMoney(insuranceInfos.value ?? 0)} />

          {bagProtectionResumeItems.map((item, index) => (
            <ProtectionResumeItemCard data={item} key={index} />
          ))}

          <GeneralInfoFooter className="mt-4 mb-8" />

          <ContractSellerButton
            type={INSURANCE_TYPE}
            beforeNavigate={handleSetInsuranceFormData}
          />

          {isWeb && (
            <View className="flex-1 justify-end hidden xl:flex mt-8">
              <Button className="w-full" onPress={handleContinue}>
                CONTINUAR PARA PAGAMENTO
              </Button>
            </View>
          )}
        </View>
      </View>
    </KeyboardScreenContainer>
  );
};

export default BagProtectionContractResume;
